/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import { AuthContext } from '@store/auth-context';

/* Services */
import { Box } from '@chakra-ui/react';
import OthersCommonUI from '@components/UI/Others/OthersCommonUI';
import ProgramFinderStore from '@components/UI/ProgramFinder/ProgramFinderStore';
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/othersService';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

import { useRouter } from 'next/router';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - ProgramFinder Landing Page Data
 */

const ProgramFinderPage = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);
  const router = useRouter();

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  // consoleLog('page', pageData);

  useEffect(() => {
    if(!router?.query?.freeTextSearch){
      if (window?.location.pathname.indexOf('/program-finder') > -1) {
        const Mixpanel = mixPanel(window?.location.pathname);
        Mixpanel.track("program_finder_pageview", {
          page_name: "Program Finder - Sadhguru & Isha Foundation",
        });
      }
  }
  },[]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <ProgramFinderStore>
        <Box as="section" className="page-wrap container-article" p="0">
          <OthersCommonUI
            pageBody={pageData?.body}
            region={region}
            lang={language}
          />
        </Box>
      </ProgramFinderStore>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const newsPaths = config.USE_LOCAL_URL
    ? [`/in/en/program-finder`, `/us/en/program-finder`]
    : await getLandingPaths('lvl0', '/program-finder', 'program-finder-us');
  return {
    paths: newsPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language, 'program-finder', {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default ProgramFinderPage;
